const UserIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 15C1 12.7909 2.79086 11 5 11H13C15.2091 11 17 12.7909 17 15V15C17 16.1046 16.1046 17 15 17H3C1.89543 17 1 16.1046 1 15V15Z"
        stroke="#737373"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <circle cx="9" cy="4" r="3" stroke="#737373" stroke-width="2" />
    </svg>
  );
};

export default UserIcon;
